import React, { useState, useEffect } from "react";

const LinkModal = ({ isOpen, onClose, onSave, selected, pages, currentPage }) => {
  const [formData, setFormData] = useState({
    clickable: false,
    useLocal: true, // Local link by default when clickable is true
    localLink: "", // Value for local link (starts with 'none')
    externalLink: "", // Value for external link
  });

  const [pageIds, setPageIds] = useState([]);

  useEffect(() => {
    if (selected) {
      // Initialize formData with selected values if necessary
      setFormData({
        clickable: selected.clickable || false,
        useLocal: selected.useLocal || true,
        localLink: selected.localLink || "none",
        externalLink: selected.externalLink || "",
      });
    }

    let ids = new Map();
    if(pages?.length > 0)
    {          

        pages.forEach((page, index) => {

            if(index !== currentPage-1)
            {
              const [root, num] = page.pageId.split("_");
              ids.set(root, root);
            }
            
        });
        setPageIds(Array.from(ids.values()));
    }
  }, [selected]);

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleSave = () => {
    selected.clickable = formData.clickable; 
    selected.useLocal = formData.useLocal;
    selected.localLink = formData.localLink;
    selected.externalLink = formData.externalLink;

    if (onSave) onSave(formData);
    onClose();
  };

  if (!isOpen) return null;

  const styles = {
    backdrop: {
      position: "fixed",
      inset: 0,
      backgroundColor: "rgba(0, 0, 0, 0.4)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 50,
    },
    modal: {
      backgroundColor: "#fff",
      borderRadius: "8px",
      padding: "20px",
      width: "90%",
      maxWidth: "500px",
      maxHeight: "90vh",
      overflowY: "auto",
      boxShadow: "0 5px 15px rgba(0,0,0,0.3)",
    },
    label: { display: "block", marginBottom: "10px", fontSize: "14px" },
    input: {
      display: "block",
      width: "100%",
      padding: "6px 10px",
      marginTop: "5px",
      border: "1px solid #ccc",
      borderRadius: "4px",
      fontSize: "14px",
      boxSizing: "border-box",
    },
    colorInput: {
      display: "inline-block",
      width: "60px",
      height: "35px",
      marginTop: "5px",
      border: "1px solid #ccc",
      borderRadius: "4px",
      cursor: "pointer",
    },
    modalButtons: {
      display: "flex",
      justifyContent: "flex-end",
      gap: "10px",
      marginTop: "20px",
    },
    button: {
      padding: "6px 12px",
      fontSize: "14px",
      borderRadius: "4px",
      border: "none",
      cursor: "pointer",
    },
    cancel: { backgroundColor: "#e0e0e0" },
    save: { backgroundColor: "#007bff", color: "#fff" },
    section: {
      marginBottom: "20px",
      padding: "10px",
      backgroundColor: "#f9f9f9",
      borderRadius: "6px",
      border: "1px solid #dddddd",
    },
    sectionTitle: {
      fontSize: "16px",
      fontWeight: "bold",
      marginBottom: "10px",
    },
    disabled: {
      backgroundColor: "#f2f2f2",
      color: "#ccc",
      cursor: "not-allowed",
    },
    checkbox: {
      marginRight: "10px",
    },
    greyedText: {
      color: "#ccc", // Style for greyed out text (labels)
    },
    darkText: {
      color: "#000", // Style for active text
    },
  };

  const isLocalLinkDisabled = !formData.clickable || !formData.useLocal;
  const isRemoteLinkDisabled = !formData.clickable || formData.useLocal;

  return (
    <div style={styles.backdrop}>
      <div style={styles.modal}>
        <h2>Link Settings</h2>

        {/* Clickable Checkbox */}
        <div style={{ display: "flex", alignItems: "center" }}>
          <input
            type="checkbox"
            checked={formData.clickable}
            onChange={(e) => handleChange("clickable", e.target.checked)}
            style={styles.checkbox}
          />
          <label style={styles.label}>Clickable</label>
        </div>

        {/* Section for Local/Remote Link Selection */}
        <div style={styles.section}>
          <div style={styles.sectionTitle}>Link Type</div>
          <div style={{ display: "flex", alignItems: "center" }}>
            <input
              type="checkbox"
              checked={formData.useLocal}
              onChange={(e) => handleChange("useLocal", e.target.checked)}
              style={styles.checkbox}
              disabled={!formData.clickable}
            />
            <label
              style={{
                ...styles.label,
                ...(formData.useLocal ? styles.darkText : styles.greyedText),
              }}
            >
              Use Local Link
            </label>
          </div>
        </div>

        {/* Local Link Section */}
        <div
          style={{
            ...styles.section,
            ...(isLocalLinkDisabled ? styles.disabled : {}),
          }}
        >
          <div style={styles.sectionTitle}>Local Link</div>
          <select
            value={formData.localLink}
            onChange={(e) => handleChange("localLink", e.target.value)}
            disabled={isLocalLinkDisabled}
            style={styles.input}
          >
            <option value="none">None</option>
            {pageIds.map((pageId) => (
                    <option key={pageId} value={pageId}>
                        {pageId.slice(-5)} {/* Show last 5 characters */}
                    </option>
                    ))}

          </select>
        </div>

        {/* Remote Link Section */}
        <div
          style={{
            ...styles.section,
            ...(isRemoteLinkDisabled ? styles.disabled : {}),
          }}
        >
          <div style={styles.sectionTitle}>Remote Link</div>
          <input
            type="text"
            value={formData.externalLink}
            onChange={(e) => handleChange("externalLink", e.target.value)}
            disabled={isRemoteLinkDisabled}
            style={styles.input}
          />
        </div>

        {/* Modal Buttons */}
        <div style={styles.modalButtons}>
          <button style={{ ...styles.button, ...styles.cancel }} onClick={onClose}>
            Cancel
          </button>
          <button style={{ ...styles.button, ...styles.save }} onClick={handleSave}>
            Apply
          </button>
        </div>
      </div>
    </div>
  );
};

export default LinkModal;

